module.exports = __webpack_public_path__ + "static/media/Trade Gothic-01.cc90fbad.svg";